module.exports = __webpack_public_path__ + "img/13.b3b7c4d1.jpg";